import { FC } from 'react';

import { Loading } from '@argenta/react-ui';
import { t } from '@lingui/macro';

import { VacanciesOverview } from '../../components/VacanciesOverview';
import { useFetchTopVacancies } from '../../hooks/api/useFetchTopVacancies';

export const TopVacancies: FC = () => {
  const { topVacancies, loadingStatus } = useFetchTopVacancies();

  return (
    <div className="argnt-top-vacancies">
      <div className="argnt-top-vacancies-overview">
        <Loading
          loadingStatus={loadingStatus}
          i18nStrings={{ defaultErrorMessage: t({ id: 'vacancies.global.error.defaultMessage' }) }}
        >
          <VacanciesOverview vacancies={topVacancies} enablePager={false} showDescription={false} />
        </Loading>
      </div>
    </div>
  );
};
